import { useContext, useRef } from "react";
import PropTypes from 'prop-types';

import ProposalOutputContext from "../../../context/ProposalOutputContext";

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import Paper from '@mui/material/Paper';
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";
import Divider from '@mui/material/Divider';

const OutputSection = ({ title }) => {
  const {
    handleEditorChange, getScore, handleScoreChange,
    getProposalContent, formErrors
  } = useContext(ProposalOutputContext);
  const quillRef = useRef(null);
  return (
    <Box sx={{ width: '100%', mt: 2 }}>
      <Paper
        sx={{
          p: 2,
          borderRadius: 3,
          '&:hover': {
            boxShadow: 3,
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            py: 1,
          }}
        >
          <Typography
            component='h5'
            variant="h5"
            sx={{
              display: 'flex',
              alignItems: 'center',
              color: '#1e293b',
            }}
          >
            <strong>{title}</strong>
          </Typography>

          <Box
            sx={{
              position: 'relative',
              display: 'inline-block',
            }}
          >
            <ToggleButtonGroup
              value={getScore(title)}
              exclusive
              onChange={(event, newValue) => handleScoreChange(title, newValue)}
              size="small"
              sx={{
                '& .MuiToggleButton-root': {
                  px: 1.2,
                  py: 0.3,
                  fontSize: '0.8125rem',
                  fontWeight: 600,
                  borderColor: formErrors[title] ? '#FCA5A5' : '#E2E8F0',
                  color: '#64748B',
                  '&.Mui-selected': {
                    backgroundColor: '#0F172A',
                    color: '#FFFFFF',
                    borderColor: '#0F172A',
                    '&:hover': { backgroundColor: '#1E293B' },
                  },
                },
              }}
            >
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
                <ToggleButton key={num} value={num}>
                  {num}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>

            {formErrors[title] && (
              <Typography
                variant="caption"
                sx={{
                  color: '#DC2626',
                  fontWeight: 500,
                  position: 'absolute',
                  top: '100%',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  mt: '4px',
                  whiteSpace: 'nowrap',
                  width: 'max-content',
                }}
              >
                Score is required before proceeding
              </Typography>
            )}
          </Box>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box
          sx={{
            maxHeight: 500,
            overflowY: 'auto',
            my: 1
          }}>
          <ReactQuill
            ref={quillRef}
            value={getProposalContent(title)}
            onChange={(content) => handleEditorChange(content, title)}
            modules={{
              toolbar: false
            }}
            theme="snow"
          />
        </Box>
      </Paper>
    </Box>
  );
};

OutputSection.propTypes = {
  title: PropTypes.string.isRequired,
};

export default OutputSection;